import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'addin-root',
  templateUrl: './not-enabled.component.html',
  styleUrls: ['./not-enabled.component.scss'],
  imports: [TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotEnabledComponent {}
